import React, { useState } from 'react';
import { Modal, Button, Card } from 'react-bootstrap';
import './QuizzBtn.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

const CustomCard = ({name, createUser, questions, id}) => {
  const startQuizz = (quizzId)=>{
    window.location.href='/sondage/'+quizzId;
  }
  return (
    <Card className="quizz-card" >
        <Card.Body>
            <Card.Title>{name}</Card.Title>
            <Card.Text>By: {createUser}</Card.Text>
                <div className="quizz-info">
                    <span><FontAwesomeIcon icon={faQuestionCircle} /> {questions} Questions</span>
              </div>
              <Button onClick={()=>startQuizz(id)} variant="primary" className="mt-3 w-100">
                
                Commencer le Sondage
              </Button>
        </Card.Body> 
    </Card>
  );
};

export default CustomCard;